import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/login/Main.vue'
import ErrorPage from '../views/error-page/Main.vue'
import store from '../store'

import BlankPage from '../layouts/blank/Main.vue'
import Privacy from '../views/privacy/privacyAndPolicy.vue'

const routes = [
  {
    path: '/',
    name: 'blankPage',
    redirect: { name: 'login' },
    component: BlankPage,
    children: [
      {
        path: 'memo/memoDoc/approve',
        name: 'memoApprove',
        component: () => import('../views/memo/myactivities/Approve.vue')
      },
      {
        path: 'reimbursement/pv/approve',
        name: 'pvApprove',
        component: () => import('../views/reimbursement/pv/Approve.vue')
      },
      {
        path: 'reimbursement/ca/approve',
        name: 'caApprove',
        component: () => import('../views/reimbursement/ca/Approve.vue')
      },
      {
        path: 'reimbursement/cl/approve',
        name: 'clApprove',
        component: () => import('../views/reimbursement/cl/Approve.vue')
      },
      {
        path: 'procurement/pr/approve',
        name: 'prApprove',
        component: () => import('../views/procurement/pr/Approve.vue')
      },
      {
        path: 'procurement/po/approve',
        name: 'poApprove',
        component: () => import('../views/procurement/po/Approve.vue')
      },
      {
        path: 'procurement/gr/approve',
        name: 'grApprove',
        component: () => import('../views/procurement/gr/Approve.vue')
      },
      {
        path: 'preorder/of/approve',
        name: 'ofApprove',
        component: () => import('../views/preorder/of/Approve.vue')
      },
      {
        path: 'preorder/rf/approve',
        name: 'rfApprove',
        component: () => import('../views/preorder/rf/Approve.vue')
      },
      {
        path: 'privacy-policy',
        name: 'privacyAndPolicy',
        component: Privacy
      }
    ]
  },
  {
    path: '/modules',
    // component: TopMenu,
    component: () => import('../layouts/top-menu/Main.vue'),
    children: [
      {
        path: '/',
        name: 'modules',
        component: () => import('../views/dashboard/Main.vue')
      },
      {
        path: 'all',
        name: 'all',
        component: () => import('../views/dashboard/Main.vue')
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('../views/dashboard/Main.vue')
      }
    ]
  },
  // memo
  {
    path: '/memo',
    name: 'memoMyActivities',
    component: () => import('../layouts/top-menu/Main.vue'),
    redirect: { name: 'memoDocAll' },
    children: [
      {
        path: '/',
        name: 'memoDashboard',
        component: () => import('../views/memo/dashboard/Main.vue')
      },
      {
        path: 'myActivities',
        name: 'memoMyActivities',
        redirect: '/memo/myActivities/wait'
      },
      {
        path: 'myActivities/wait',
        name: 'memoMyActivitiesWait',
        component: () => import('../views/memo/myactivities/List.vue')
      },
      {
        path: 'myActivities/myDoc',
        name: 'memoMyActivitiesMyDoc',
        component: () => import('../views/memo/myactivities/ListMyDoc.vue')
      },
      {
        path: 'myActivities/form',
        name: 'memoMyActivitiesForm',
        component: () => import('../views/memo/myactivities/Form.vue')
      },
      {
        path: 'myActivities/form/:id/edit',
        name: 'memoMyActivitiesFormEdit',
        component: () => import('../views/memo/myactivities/Form.vue')
      },
      {
        path: 'myActivities/form/:id/detail',
        name: 'memoMyActivitiesFormDetail',
        component: () => import('../views/memo/myactivities/Detail.vue')
      },
      {
        path: 'memoDoc',
        name: 'memoDoc',
        redirect: { name: 'memoDocAll' }
      },
      {
        path: 'memoDoc/all',
        name: 'memoDocAll',
        component: () => import('../views/memo/doc/List.vue')
      }
    ]
  },
  {
    path: '/broadcast',
    name: 'broadcast',
    component: () => import('../layouts/top-menu/Main.vue'),
    children: [
      {
        path: 'list',
        name: 'broadcastList',
        component: () => import('../views/broadcast/List.vue')
      }
    ]
  },
  // remibursement
  {
    path: '/reimbursement',
    name: 'reimbursement',
    component: () => import('../layouts/top-menu/Main.vue'),
    children: [
      {
        path: '/',
        name: 'reimbursementDashboard',
        component: () => import('../views/reimbursement/Main.vue')
      },
      {
        path: 'cl',
        name: 'reimbursementClWait',
        component: () => import('../views/reimbursement/cl/Main.vue'),
        children: [
          {
            path: 'myDocWait',
            name: 'reimbursementClMyWait',
            component: () => import('../views/reimbursement/cl/List.vue')
          },
          {
            path: 'form',
            name: 'reimbursementClForm',
            component: () => import('../views/reimbursement/cl/Form.vue')
          },
          {
            path: 'form/:id/edit',
            name: 'reimbursementClFormEdit',
            component: () => import('../views/reimbursement/cl/Form.vue')
          },
          {
            path: 'form/:id/detail',
            name: 'reimbursementClFormDetail',
            component: () => import('../views/reimbursement/cl/Detail.vue')
          }
        ]
      },
      {
        path: 'ca',
        name: 'reimbursementCaWait',
        component: () => import('../views/reimbursement/ca/Main.vue'),
        children: [
          {
            path: 'myDocWait',
            name: 'reimbursementCaMyWait',
            component: () => import('../views/reimbursement/ca/List.vue')
          },
          {
            path: 'form',
            name: 'reimbursementCaForm',
            component: () => import('../views/reimbursement/ca/Form.vue')
          },
          {
            path: 'form/:id/edit',
            name: 'reimbursementCaFormEdit',
            component: () => import('../views/reimbursement/ca/Form.vue')
          },
          {
            path: 'form/:id/detail',
            name: 'reimbursementCaFormDetail',
            component: () => import('../views/reimbursement/ca/Detail.vue')
          }
        ]
      },
      {
        path: 'pv',
        name: 'reimbursementPvMyDocWait',
        redirect: { name: 'reimbursementPvMyWait' }
      },
      {
        path: 'pv/myDocWait',
        name: 'reimbursementPvMyWait',
        component: () => import('../views/reimbursement/pv/List.vue')
      },
      {
        path: 'pv/form',
        name: 'reimbursementPvForm',
        component: () => import('../views/reimbursement/pv/Form.vue')
      },
      {
        path: 'pv/form/:id/edit',
        name: 'reimbursementPvFormEdit',
        component: () => import('../views/reimbursement/pv/Form.vue')
      },
      {
        path: 'pv/form/:id/detail',
        name: 'reimbursementPvFormDetail',
        component: () => import('../views/reimbursement/pv/Detail.vue')
      }
    ]
  },
  // procurement
  {
    path: '/procurement',
    name: 'procurement',
    component: () => import('../layouts/top-menu/Main.vue'),
    children: [
      {
        path: 'pr',
        name: 'procurementPRWait',
        component: () => import('../views/procurement/pr/Main.vue'),
        redirect: { name: 'procurementPRList' },
        children: [
          {
            path: 'myDocWait',
            name: 'procurementPRList',
            component: () => import('../views/procurement/pr/List.vue')
          },
          {
            path: 'form',
            name: 'procurementPRForm',
            component: () => import('../views/procurement/pr/Form.vue')
          },
          {
            path: 'form/:id/edit',
            name: 'procurementPRFormEdit',
            component: () => import('../views/procurement/pr/Form.vue')
          },
          {
            path: 'form/:id/detail',
            name: 'procurementPRFormDetail',
            component: () => import('../views/procurement/pr/Detail.vue')
          }
        ]
      },
      {
        path: 'po',
        name: 'procurementPOWait',
        component: () => import('../views/procurement/po/Main.vue'),
        redirect: { name: 'procurementPOList' },
        children: [
          {
            path: 'myDocWait',
            name: 'procurementPOList',
            component: () => import('../views/procurement/po/List.vue')
          },
          {
            path: 'form',
            name: 'procurementPOForm',
            component: () => import('../views/procurement/po/Form.vue')
          },
          {
            path: 'form/:id/edit',
            name: 'procurementPOFormEdit',
            component: () => import('../views/procurement/po/Form.vue')
          },
          {
            path: 'form/:id/detail',
            name: 'procurementPOFormDetail',
            component: () => import('../views/procurement/po/Detail.vue')
          }
        ]
      },
      {
        path: 'gr',
        name: 'procurementGRWait',
        component: () => import('../views/procurement/gr/Main.vue'),
        redirect: { name: 'procurementGRList' },
        children: [
          {
            path: 'myDocWait',
            name: 'procurementGRList',
            component: () => import('../views/procurement/gr/List.vue')
          },
          {
            path: 'form',
            name: 'procurementGRForm',
            component: () => import('../views/procurement/gr/Form.vue')
          },
          {
            path: 'form/:id/edit',
            name: 'procurementGRFormEdit',
            component: () => import('../views/procurement/gr/Form.vue')
          },
          {
            path: 'form/:id/detail',
            name: 'procurementGRFormDetail',
            component: () => import('../views/procurement/gr/Detail.vue')
          }
        ]
      }
    ]
  },
  // pre-order
  {
    path: '/preorder',
    name: 'preorder',
    component: () => import('../layouts/top-menu/Main.vue'),
    children: [
      {
        path: 'of',
        name: 'preorderOFWait',
        component: () => import('../views/preorder/of/Main.vue'),
        redirect: { name: '' },
        children: [
          {
            path: 'myDocWait',
            name: 'preorderOFList',
            component: () => import('../views/preorder/of/List.vue')
          },
          {
            path: 'form',
            name: 'preorderOFForm',
            component: () => import('../views/preorder/of/Form.vue')
          },
          {
            path: 'form/:id/edit',
            name: 'preorderOFFormEdit',
            component: () => import('../views/preorder/of/Form.vue')
          },
          {
            path: 'form/:id/detail',
            name: 'preorderOFFormDetail',
            component: () => import('../views/preorder/of/Detail.vue')
          }
        ]
      },
      {
        path: 'rf',
        name: 'preorderRFWait',
        component: () => import('../views/preorder/rf/Main.vue'),
        redirect: { name: '' },
        children: [
          {
            path: 'myDocWait',
            name: 'preorderRFList',
            component: () => import('../views/preorder/rf/List.vue')
          },
          {
            path: 'form',
            name: 'preorderRFForm',
            component: () => import('../views/preorder/rf/Form.vue')
          },
          {
            path: 'form/:id/edit',
            name: 'preorderRFFormEdit',
            component: () => import('../views/preorder/rf/Form.vue')
          },
          {
            path: 'form/:id/detail',
            name: 'preorderRFFormDetail',
            component: () => import('../views/preorder/rf/Detail.vue')
          }
        ]
      }
    ]
  },
  // employee
  {
    path: '/employee',
    // component: TopMenu,
    component: () => import('../layouts/top-menu/Main.vue'),
    redirect: { name: 'employeeList' },
    children: [
      {
        path: 'all',
        name: 'employeeAll',
        component: () => import('../views/employee/List.vue')
      }
    ]
  },
  // material
  {
    path: '/material',
    // component: TopMenu,
    component: () => import('../layouts/top-menu/Main.vue'),
    redirect: { name: 'materialList' },
    children: [
      {
        path: 'all',
        name: 'materialAll',
        component: () => import('../views/material/List.vue')
      }
    ]
  },
  // budget
  {
    path: '/budget',
    name: 'budget',
    component: () => import('../layouts/top-menu/Main.vue'),
    children: [
      {
        path: 'all',
        name: 'budgetAll',
        component: () => import('../views/budget/List.vue')
      },
      {
        path: 'manageReader/:budget_id',
        name: 'manageReaderForm',
        component: () => import('../views/budget/Form.vue')
      }
    ]
  },
  // special path
  {
    path: '/specialPath',
    name: 'specialPath',
    component: () => import('../layouts/top-menu/Main.vue'),
    children: [
      {
        path: 'all',
        name: 'specialPathAll',
        component: () => import('../views/special-path/List.vue')
      },
      {
        path: 'form',
        name: 'specialPathForm',
        component: () => import('../views/special-path/Form.vue')
      },
      {
        path: 'form/:name',
        name: 'specialPathFormEdit',
        component: () => import('../views/special-path/Form.vue')
      }
    ]
  },
  // vendor
  {
    path: '/vendor',
    name: 'vendor',
    component: () => import('../layouts/top-menu/Main.vue'),
    children: [
      {
        path: 'all',
        name: 'vendorAll',
        component: () => import('../views/vendor/List.vue')
      }
      // {
      //   path: 'manageReader/:vendor_id',
      //   name: 'manageReaderForm',
      //   component: () => import('../views/vendor/Form.vue')
      // }
    ]
  },

  // login, logout
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logout')
        store.commit('global/setInit')
        next()
      }
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: Login,
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logout')
        // store.commit('memo/initState')
        next('/login')
      }
    }
  },
  {
    path: '/error-page',
    name: '/error-page',
    component: ErrorPage
  },
  {
    path: '/:pathMatch(.*)*',
    component: ErrorPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { left: 0, top: 0 }
  }
})

router.beforeEach((routeTo, routeFrom, next) => {
  const publicPages = [
    '/login',
    '/memo/memoDoc/approve',
    '/reimbursement/pv/approve',
    '/reimbursement/ca/approve',
    '/reimbursement/cl/approve',
    '/procurement/pr/approve',
    '/procurement/po/approve',
    '/procurement/gr/approve',
    '/preorder/of/approve',
    '/preorder/rf/approve',
    '/privacy-policy'
  ]
  const authpage = !publicPages.includes(routeTo.path)
  const token = localStorage.getItem('token')
  const info = localStorage.getItem('info')
  const role = localStorage.getItem('role')
  if (authpage && (!token || !info || !role)) {
    return next('/login')
  }
  next()
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
    }
  } catch (error) {
    return
  }
  next()
})

export default router
